// extracted by mini-css-extract-plugin
export default {"container":"Question_container__4PyN8","questionText":"Question_questionText__EejY3","fadeOut":"Question_fadeOut__JFJef"};